import { FormControl } from '@angular/forms';

export class ForeignAddress {
    public line1: string;
    public line2: string;
    public line3: string;
    public country: Country;
}

export interface ForeignAddressForm {
    line1: FormControl<string>;
    line2: FormControl<string>;
    line3: FormControl<string>;
    country: FormControl<string | Country>;
}

export class Country {
    public code: string;
    public name: string;
}
